<template>
  <div class="u-containar-md registerForm">
    <p class="lead">
      設定いただいたメールアドレスにメールをお送りしました。<br />
      メールに記載されているURLから利用登録をお願いします。
    </p>
    <div class="box">
      <p>
        まだ利用登録は完了していません。
      </p>
      <p>
        ドメイン指定受信を設定されている場合、メールが届かない場合があります。<br />
        その場合、info@mynavi.jpを受信許可設定いただき、再度メールアドレスの設定をお願いします。
      </p>
      <p>
        また、メール内URLの有効期限は送信から12時間のみとなっております。<br />12時間を過ぎてURLをクリックした場合、改めて会員登録用のURLを発行する必要がありますので、再度メールアドレスの設定をお願いいたします。
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.lead {
  text-align: center;
  margin-bottom: 2em;
}
.box {
  color: var.$color-primary;
  background-color: #e7f8f6;
  text-align: center;
  padding: 2em;
  p:first-of-type {
    font-size: 1.6rem;
    font-weight: bold;
  }
  p:not(:last-of-type) {
    margin-bottom: 1em;
  }
}
</style>
